export default {
  为您找到: 'Found',
  未知模块: 'Unknown module',
  相关: 'related',
  结果: 'results',
  抱歉没有找到: 'Sorry not found',
  一键已读: 'One-click read',
  暂无相关的云数据: 'No related cloud data',
}
